import React from 'react';
import { Loader2, Activity, AlertTriangle, ShieldAlert, RefreshCw } from 'lucide-react';

interface HealthCardProps {
  systemHealth: { status: string, message: string };
  checkSystemHealth: () => void;
}

const HealthCard: React.FC<HealthCardProps> = ({ systemHealth, checkSystemHealth }) => {
  const statusConfig = {
    checking: { color: 'border-gray-500', icon: Loader2, iconClass: 'text-gray-500 animate-spin' },
    ok: { color: 'border-green-500', icon: Activity, iconClass: 'text-green-500' },
    warning: { color: 'border-yellow-500', icon: AlertTriangle, iconClass: 'text-yellow-500' },
    error: { color: 'border-red-500', icon: ShieldAlert, iconClass: 'text-red-500' }
  };

  const config = statusConfig[systemHealth.status as keyof typeof statusConfig] || statusConfig.checking;
  const Icon = config.icon;

  return (
    <div className={`bg-white border-l-4 ${config.color} rounded-lg shadow-md p-4 col-span-1 md:col-span-2`}>
      <div className="flex items-center">
        <div className={`p-3 rounded-full ${config.color.replace('border-', 'bg-')} bg-opacity-10`}>
          <Icon className={`h-6 w-6 ${config.iconClass}`} />
        </div>
        <div className="ml-4">
          <p className="text-gray-500 text-sm font-medium">Status do Sistema</p>
          <p className="text-lg font-semibold">{systemHealth.message}</p>
        </div>
        <div className="ml-auto">
          <button 
            onClick={checkSystemHealth} 
            className="p-2 text-gray-500 hover:text-gray-700"
            aria-label="Verificar novamente"
          >
            <RefreshCw className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default HealthCard; 